import React from 'react'
import { Drawer, Empty, Flex, List, Result, Space } from 'antd'
import { questionActions } from '../../../../../../store/slices/question.slice'
import { useDispatch, useSelector } from 'react-redux'
import { useFetchQuestionChangesHistoryQuery, useFetchQuestionsQuery } from '../../../../../../store/apis/question.api'
import questionSelectors from '../../../../../../store/selectors/question.selectors'
import Text from 'antd/es/typography/Text'
import { sqlToJsDate, sqlToTimeFromNow } from '../../../../../../utils/date.helper'
import { ArrowRightOutlined } from '@ant-design/icons'
import { fetchQuestionsSelectors } from '../../../../../../store/apis/utils/selectors/question.api.selectors'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import { useParams } from 'react-router'
import PatternIcon from '../../../../../../components/common/PatternIcon'
import { capitalize } from 'lodash'

const normalizeFieldName = field => {
    if (field === 'grading_reference_content') return 'grading reference content'
    if (field === 'text') return 'content'
    return field
}

const ChangesHistoryDrawer = () => {
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    const dispatch = useDispatch()
    const versionId = useVersionId()
    const { token } = useParams()

    const {
        data: history,
        isFetching,
        error,
    } = useFetchQuestionChangesHistoryQuery({
        id: editingQuestionId,
        versionId,
    })
    const { data: editingQuestion } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.byId({ id: editingQuestionId }, result),
        },
    )

    const handleClose = () => dispatch(questionActions.setShowChangesHistoryDrawer(false))

    if (error) return <Result status='error' title='Changes history fetch failed' subTitle={error} />

    return (
        <Drawer title='Changes history' autoFocus onClose={handleClose} open width={560} destroyOnClose>
            <List
                dataSource={history}
                loading={{ spinning: isFetching, tip: 'Loading history...' }}
                locale={{ emptyText: <Empty description='Changes history is empty' /> }}
                renderItem={item => {
                    let target
                    const isCategoryChange = /^[0-9]+_/.test(item.field)
                    if (isCategoryChange) {
                        const categoryId = Number(item.field.split('_')[0])
                        const category = editingQuestion.categories.find(category => category.id === categoryId)

                        target = (
                            <Space size={4}>
                                <PatternIcon
                                    id={categoryId}
                                    colorId={category.colorId}
                                    content={category.grade}
                                    suffix='pt'
                                />
                                {category.name + "'s"}
                                {normalizeFieldName(item.field.split('_').slice(1).join('_'))}
                            </Space>
                        )
                    } else {
                        target = capitalize(normalizeFieldName(item.field))
                    }
                    const changeDate = (
                        <Text type='secondary' title={sqlToJsDate(item.createdAt)}>
                            {sqlToTimeFromNow(item.createdAt)}
                        </Text>
                    )

                    const actionDescription = 'changed'

                    return (
                        <List.Item key={item.createdAt}>
                            <Flex vertical gap={8}>
                                <div>
                                    {target} {actionDescription} {changeDate}
                                </div>
                                <Space size={4}>
                                    {item.oldValue || 'None'}
                                    <ArrowRightOutlined />
                                    {item.newValue || 'None'}
                                </Space>
                            </Flex>
                        </List.Item>
                    )
                }}
            />
        </Drawer>
    )
}

export default ChangesHistoryDrawer
